import { parse } from '@handlebars/parser';
import { useTranslation } from '../useTranslation';

export const useValidateHandlebarsSyntaxInContent = () => {
  const { t } = useTranslation();

  return (content = '') => {
    try {
      parse(content);
    } catch (error) {
      console.error(error);
      return t('contentPicker.textEditor.invalidHandlebarsSyntaxError');
    }
  };
};
